import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import QRCode from 'react-qr-code';
import { useTranslation } from 'react-i18next';

import { ReactComponent as IconQRCode } from 'src/assets/icons/icon-qr-code.svg';

import { selectTagValue } from 'src/store/slice/payment/state';

import PopupContent from 'src/components/popups/popupContent';
import Button from 'src/components/button';

import './popup-qr-code.scss';

const PopupQrCode: React.FC = (): JSX.Element => {
  const { t } = useTranslation();

  const tagValue = useSelector(selectTagValue);

  const [isShowPopup, setShowPopup] = useState<boolean>(false);

  const onTogglePopup = () => {
    setShowPopup(!isShowPopup);
  };

  return (
    <>
      <Button
        wrapperClass="button-qr-code"
        icon={<IconQRCode />}
        onEvent={onTogglePopup}
      />

      <PopupContent
        wrapperClass="popup-qr-code"
        visible={isShowPopup}
        onClickLayout={onTogglePopup}
      >
        <p className="qr-code">
          <QRCode
            value={`${tagValue}`}
            style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
            viewBox={`0 0 256 256`}
          />
        </p>

        <p className="qr-code-description">Scan with your phone camera or the wallet app</p>
      </PopupContent>
    </>
  );
};

export default PopupQrCode;
